import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import francais from 'vuetify/es5/locale/fr'

const opts = {
    icons: {
        iconfont: 'mdiSvg',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary:   '#90b365',
                secondary: '#73191c',
                accent:    '#82B1FF',
                error:     '#FF5252',
                info:      '#90b365',
                success:   '#4CAF50',
                warning:   '#FFC107',
                barrinfo:  '#F6F8F8',
            }
        }
    },
    lang: {
        locales: { francais },
        current: 'francais',
    },
}

export default new Vuetify( opts );
